// @flow
import React from "react";
import dayjs from "dayjs";
import localDateTimeIso8601 from "@justpark/helpers/src/localDateTimeIso8601/localDateTimeIso8601";
import TimeSelect from "../TimeSelect";

import styles from "./datePickerWithTimeDropDown.module.scss";
import Calendar from "../Calendar";

type Props = {
  onDateChange: (string) => void,
  date: string,
  showTimePicker: boolean,
  onClose: () => void,
  buttonText: string,
  minDate: string,
  maxDate: string,
  timeText: string
};

const DatePickerWithTimeDropDown = ({
  onDateChange,
  date,
  showTimePicker = true,
  minDate,
  maxDate,
  onClose,
  buttonText,
  timeText
}: Props) => {
  const dateInstance = dayjs(date);

  const onCalendarDateChange = (newDate) => {
    const dateOnlyInstance = dayjs(newDate);

    const newDateInstance = dateInstance
      .set("year", dateOnlyInstance.get("year"))
      .set("month", dateOnlyInstance.get("month"))
      .set("date", dateOnlyInstance.get("date"));

    return onDateChange(newDateInstance.format(localDateTimeIso8601));
  };

  return (
    <div className={styles.container}>
      <div className={styles.datePicker}>
        <Calendar
          date={date}
          onChange={onCalendarDateChange}
          minDate={minDate}
          maxDate={maxDate}
        />
      </div>

      <div className={styles.footer}>
        {showTimePicker && (
          <div className={styles.timeContainer}>
            <span className={styles.timeText}>{timeText}</span>

            <TimeSelect
              onTimeChange={onDateChange}
              date={dateInstance.format(localDateTimeIso8601)}
              className={styles.time}
            />
          </div>
        )}

        <button
          type="button"
          onClick={onClose}
          className={styles.button}
          data-cy="datepicker-close-button"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default DatePickerWithTimeDropDown;
